import { privilegeMatches } from "./privileges";

/**
 * Check if an admin can perform an action.
 * fullAccess covers production cases where new privilege slugs
 * were added after the admin was created as "full access".
 * view_X / view_any_X are treated as the same privilege.
 */
export const can = (privileges = [], slug, fullAccess = false) => {
  if (fullAccess) return true;
  return privilegeMatches(privileges, slug);
};

export default can;
